import { render, staticRenderFns } from "./zongheSendMsg.vue?vue&type=template&id=381d589a&scoped=true&"
import script from "./zongheSendMsg.vue?vue&type=script&lang=js&"
export * from "./zongheSendMsg.vue?vue&type=script&lang=js&"
import style0 from "./zongheSendMsg.vue?vue&type=style&index=0&id=381d589a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d589a",
  null
  
)

export default component.exports